import { render, staticRenderFns } from "./SocialMedia.vue?vue&type=template&id=4fdef7be"
import script from "./SocialMedia.vue?vue&type=script&lang=js"
export * from "./SocialMedia.vue?vue&type=script&lang=js"
import style0 from "./SocialMedia.vue?vue&type=style&index=0&id=4fdef7be&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports